import { useSelector } from "react-redux";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api/lib/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useAvailabilityHotelPrice } from "@tenant/hotels";
import { getTotalNights } from "../../../../features/availability/store/selectors";
import defaultStyles from "./DealTag.module.scss";

export type DealTagProps = PlatformComponentProps & {
  hotel: Lodging;
};

export const DealTag = ({ hotel }: DealTagProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelCardDealTag,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.HotelCardDealTag
  );
  const totalNights = useSelector(getTotalNights);
  const availabilityHotelPrice = useAvailabilityHotelPrice(hotel, totalNights);
  const { t } = useI18nContext();

  if (
    !availabilityHotelPrice ||
    !availabilityHotelPrice.text.pricePerNight.difference.percentage
  ) {
    return null;
  }

  const percentageDiscount =
    availabilityHotelPrice.text.pricePerNight.difference.percentage;

  return (
    <div className={block}>
      <span className={cn("tag")}>
        {t("core-hotels.availabilityPage.results.hotelCard.save", {
          amount: percentageDiscount,
        })}
      </span>
    </div>
  );
};
